import LocationGroups from './LocationGroups';

export default LocationGroups;
